import { connect } from 'react-redux'
import Providers from './providers'
import {
  getProvidersList,
  getRemoveProviderRequest
} from '../../../../../stores/providers/providers.selectors'

const mapStateToProps = state => ({
  providers: getProvidersList(state),
  pending: getRemoveProviderRequest(state).pending
})

export default connect(
  mapStateToProps,
  null
)(Providers)
